<template>
  <v-card flat>
    <!--    <v-card-title class="headline">-->
    <!--      Лицензии на основе данной Мастер-Лицензии-->
    <!--      <v-spacer></v-spacer>-->
    <!--      <v-text-field-->
    <!--          v-if="licenses"-->
    <!--          v-model="search"-->
    <!--          append-icon="mdi-magnify"-->
    <!--          label="Поиск"-->
    <!--          single-line-->
    <!--          hide-details-->
    <!--      ></v-text-field>-->
    <!--    </v-card-title>-->

    <v-data-table
      class="ma-3"
      :search="search"
      :headers="headers"
      :items="licenses"
      :item-class="(item) => (item.isDeleted ? 'deleted' : '')"
      no-data-text="Пусто"
      no-results-text="Результатов нет"
      hide-default-footer
      @click:row="editLicense"
      :custom-sort="customSort"
      sort-by="id"
      :loading="tableLoading"
      loading-text="Загрузка"
      :items-per-page="10"
    >
      <template v-slot:item.licExpires="{ item }">
        <span
          :class="{
            expired:
              new Date(new Date().toISOString().slice(0, 10)) >
              new Date(item.licExpires),
          }"
          >{{ new Date(item.licExpires).toLocaleDateString() }}</span
        >
      </template>
      <template v-slot:item.masterExpires="{ item }">
        <span
          :class="{
            expired:
              new Date(new Date().toISOString().slice(0, 10)) >
              new Date(item.masterExpires),
          }"
          >{{ new Date(item.masterExpires).toLocaleDateString() }}</span
        >
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip v-if="!item.isDeleted" top nudge-bottom="4">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              @click.stop="deleteLicenseConfirm(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Удалить</span>
        </v-tooltip>

        <v-tooltip v-else top nudge-bottom="4">
          <template v-slot:activator="{ on, attrs }">
            <v-icon @click.stop="restoreLicense(item)" v-bind="attrs" v-on="on">
              mdi-backup-restore
            </v-icon>
          </template>
          <span>Восстановить</span>
        </v-tooltip>
      </template>
      <template v-slot:top="{ pagination, options, updateOptions }">
        <div
          class="d-flex justify-space-between align-center"
          style="border-bottom: thin solid rgba(0, 0, 0, 0.12)"
        >
          <v-text-field
            v-if="$store.getters.dealers"
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
            class="pt-0 mt-0"
          ></v-text-field>

          <v-data-footer
            :pagination="pagination"
            :options="options"
            @update:options="updateOptions"
            :items-per-page-options="[10, 50, 100, -1]"
            items-per-page-text="$vuetify.dataTable.itemsPerPageText"
            style="border: none"
          />
        </div>
      </template>
      <template v-slot:item.updateTime="{ item }">
        <span>{{ formatUpdateTime(item.updateTime) }}</span>
      </template>
    </v-data-table>

    <confirmation-dialog
      ref="confirmation"
      title="Удаление Лицензии"
      agree-button="Удалить"
      disagree-button="Отмена"
      @agree="deleteLicense($event)"
    ></confirmation-dialog>
  </v-card>
</template>

<script>
import API from "@/axios/api";
import ConfirmationDialog from "@/components/ConfirmationDialog";

import FormatDateTime from "@/utils/time.js";

export default {
  components: {
    ConfirmationDialog,
  },
  props: ["masterId"],
  data() {
    return {
      deletingLicenseId: "",

      tableLoading: true,
      search: "",
      licenses: [],
      headers: [
        {
          text: "#",
          align: "start",
          value: "id",
        },
        {
          text: "Объект",
          align: "start",
          value: "objectName",
        },
        {
          text: "Дилер",
          align: "start",
          value: "dealerName",
        },
        {
          text: "Модуль ПО",
          align: "start",
          value: "moduleName",
        },
        {
          text: "Кол-во",
          align: "start",
          value: "count",
        },
        {
          text: "Фичи",
          align: "start",
          value: "features",
        },
        {
          text: "Lic Date",
          align: "center",
          value: "licExpires",
        },
        {
          text: "Max Date",
          align: "center",
          value: "masterExpires",
        },
        {
          text: "Изменил",
          align: "center",
          value: "creatorName",
        },
        {
          text: "Дата последнего изменения",
          align: "start",
          value: "updateTime",
        },
        {
          text: "Действия",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    customSort(items, index, isDesc) {
      if (index[0] === "licExpires") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(a.licExpires) > new Date(b.licExpires) ? 1 : -1;
          } else {
            return new Date(a.licExpires) > new Date(b.licExpires) ? -1 : 1;
          }
        });
      } else if (index[0] === "masterExpires") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(a.masterExpires) > new Date(b.masterExpires)
              ? 1
              : -1;
          } else {
            return new Date(a.masterExpires) > new Date(b.masterExpires)
              ? -1
              : 1;
          }
        });
      } else {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return a[index[0]] > b[index[0]] ? 1 : -1;
          } else {
            return a[index[0]] > b[index[0]] ? -1 : 1;
          }
        });
      }
      return items;
    },
    deleteLicenseConfirm(license) {
      this.deletingObjectId = license.id;
      this.$refs.confirmation.showDialog(
        license.id,
        `Вы действительно хотите удалить Лицензию на Модуль <span class="highlighted">${license.moduleName}</span> для Объекта <span class="highlighted">${license.objectName}</span> ?`
      );
    },
    deleteLicense(licenseId) {
      API.get(`licenses/${licenseId}/delete`)
        .then((response) => {
          console.log(response.data);
          this.getMasterLicenses();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    restoreLicense(license) {
      API.get(`licenses/${license.id}/restore`)
        .then((response) => {
          console.log(response.data);
          this.getMasterLicenses();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editLicense(license) {
      if (license.isDeleted) {
        this.$store.commit("showSnackbar", {
          color: "warning",
          text: "Лицензия удалена",
        });
      } else {
        this.$router.push("/licenses/" + license.id);
      }
    },
    async getMasterLicenses() {
      await API.get(`masters/${this.masterId}/licenses`)
        .then((response) => {
          console.log(response.data);
          this.licenses = response.data.licenses;
          // this.licenses.forEach(license => {
          //   license.licExpires = new Date(license.licExpires).toLocaleDateString();
          //   license.masterExpires = new Date(license.masterExpires).toLocaleDateString();
          // })
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatUpdateTime(time) {
      return FormatDateTime(time);
    },
  },
  created() {
    this.getMasterLicenses().then(() => {
      this.tableLoading = false;
    });
  },
};
</script>

<style>
.expired {
  background-color: #eccdcd;
  color: #000000;
  padding: 0.2rem 0.5rem;
  border-radius: 3px;
}
</style>
